import {useStyles} from '@wix/tpa-settings/react'
import {widgetDataHooks as DH} from '@wix/wix-events-data-hooks'
import classNames from 'classnames'
import React, {useEffect, useReducer, useRef} from 'react'
import {DynamicStyle} from '../../../../../../commons/components/dynamic-style'
import {isEditor} from '../../../../../../commons/selectors/environment'
import stylesParams from '../../../../stylesParams'
import {useWidgetState} from '../../../hooks/state-provider'
import {useEventsList} from '../../../hooks/use-events-list'
import {getCompId} from '../../../selectors/component'
import {focusFirstNewEvent} from '../../../utils/a11y'
import {CategoryTabs} from '../../category-tabs'
import {EmptyCategory} from '../../category-tabs/empty-category'
import {LoadMoreButton} from '../../load-more-button'
import {MainListTitle} from '../../main-list-title'
import {Card} from '../card'
import s from './card-list.scss'

export const CardList = () => {
  const container = useRef<HTMLDivElement>()
  const [, forceUpdate] = useReducer(x => x + 1, 0)
  const {events, hasMore, moreLoading, pageLimit} = useEventsList()

  const editor = useWidgetState(isEditor)
  const compId = useWidgetState(getCompId)

  const styles = useStyles()

  const cardsPerRow = styles.get(stylesParams.cardsPerRow)
  const eventsCount = events.length

  const columnCount = Math.min(cardsPerRow, eventsCount, pageLimit)

  useEffect(() => {
    const onResize = () => {
      forceUpdate()
    }
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  useEffect(() => {
    focusFirstNewEvent({eventsCount, pageLimit, hasMore, compId, delay: 500})
  }, [eventsCount])

  return (
    <div className={s.background}>
      {editor && (
        <DynamicStyle namespace={compId}>
          {`.${s.container} {
            --columns: ${columnCount};
          }`}
        </DynamicStyle>
      )}
      <div className={classNames(s.topPadding)}>
        <MainListTitle />
        <CategoryTabs />
      </div>
      {!events.length ? (
        <EmptyCategory />
      ) : (
        <div ref={container} className={classNames(s.container, s.contentPadding)}>
          <ul className={classNames(s.responsiveCards)} data-hook={DH.cards}>
            {events.map(event => (
              <Card event={event} key={event.id} listItem />
            ))}
          </ul>
          <LoadMoreButton hasMore={hasMore} moreLoading={moreLoading} />
        </div>
      )}
    </div>
  )
}
